import { useEffect } from "react";
import { BottomNav, DesktopSidebar, MobileHeader } from "@/components/Navigation";

// V6.0 — Auto-claim V5.3 retiré (dangereux en multi-tenant). Chaque courtier édite
// désormais son propre simulateur via /parametres/mon-simulateur (Phase 3).
function useSimulatorAutoClaim() {
  useEffect(() => { /* no-op — auto-claim retiré */ }, []);
}

export default function Layout({ children, title, subtitle, headerRight, backTo, centerTitle }) {
  useSimulatorAutoClaim();
  return (
    <div className="min-h-screen bg-[color:var(--cf-bg)]">
      <DesktopSidebar />
      <MobileHeader title={title} subtitle={subtitle} right={headerRight} backTo={backTo} centerTitle={centerTitle} />
      <main className="md:pl-64 pb-24 md:pb-6">
        <div className="max-w-6xl mx-auto px-4 md:px-8 py-4 md:py-8">{children}</div>
      </main>
      <BottomNav />
    </div>
  );
}
